import { BillingInfo } from "../../..";
import { apiService } from "../../ApiService";

/** @deprecated */
export const getCurrentSubscription = () => {
  return apiService.get<BillingInfo>({
    path: `v1/me/subscription`,
    requiresAuthPolicy: "user",
  });
};
